export function objectToFormData(o) {
  const fd = new FormData()
  for (var key in o) {
    fd.append(key, o[key])
  }
  return fd
}
